import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getSmsSendList = async (sms_group, e_line, cur_page, fr_date, to_date) => {
  const requestBody = {
    sms_group,
    e_line,
    cur_page,
    fr_date,
    to_date,
  };
  try {
    const response = await httpRequest("post", `${URL}/smsList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};
